export default __webpack_public_path__ + "media/components/Pages/Abitur/Images/How/3-294b2846bdebf0b981b8b33beec2d0cf.svg";